/**
 * 区域信息路由
 */
const RegionRouter = {
  path: 'region',
  name: 'Region',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Region/index')
}
export default RegionRouter
